
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 39 39"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.5 18.688V27.4","stroke":"#000","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.5 10.64a1.939 1.939 0 101.938 1.92 1.855 1.855 0 00-1.938-1.92z","fill":"#000"}}),_c('path',{attrs:{"d":"M19.5 37.719a18.219 18.219 0 100-36.438 18.219 18.219 0 000 36.438z","stroke":"#000","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    